<!-- CurrencyConflictModal.vue -->
<template>
  <!-- Bootstrap Modal -->
  <div
    class="modal fade"
    ref="modalEl"
    id="currencyConflictModal"
    tabindex="-1"
    aria-labelledby="currencyConflictLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      style="--bs-modal-width: 400px"
    >
      <div class="modal-content border-2 rounded-3 currency-conflict">
        <div class="modal-header bg-danger-subtle border-0">
          <h1
            class="modal-title fs-5 text-danger-emphasis"
            id="currencyConflictLabel"
          >
            ⚠️ Critical Warning (Currency Conflict)
          </h1>
        </div>

        <div class="modal-body">
          <p class="text-muted small mb-3">
            Hover(또는 클릭)하여 각 언어의 상세 메시지를 확인하세요.
          </p>

          <!-- Accordion (언어별 안내) -->
          <div class="accordion accordion-flush" id="langAccordion">
            <!-- English -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-en">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-en"
                  aria-expanded="false"
                  aria-controls="cp-en"
                >
                  English
                </button>
              </h2>
              <div
                id="cp-en"
                class="accordion-collapse collapse"
                aria-labelledby="hd-en"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p><strong>Critical Warning (Currency Conflict)</strong></p>
                  <p>
                    Selected items (or cart) contain different currencies.<br />Please
                    unify your currency before proceeding.
                  </p>
                </div>
              </div>
            </div>

            <!-- Español -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-es">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-es"
                  aria-expanded="false"
                  aria-controls="cp-es"
                >
                  Español
                </button>
              </h2>
              <div
                id="cp-es"
                class="accordion-collapse collapse"
                aria-labelledby="hd-es"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p>
                    <strong>Advertencia Crítica (Conflicto de Moneda)</strong>
                  </p>
                  <p>
                    Los artículos seleccionados (o el carrito) contienen
                    diferentes monedas.<br />Por favor, unifica tu moneda antes
                    de continuar.
                  </p>
                </div>
              </div>
            </div>

            <!-- Português -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-pt">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-pt"
                  aria-expanded="false"
                  aria-controls="cp-pt"
                >
                  Português
                </button>
              </h2>
              <div
                id="cp-pt"
                class="accordion-collapse collapse"
                aria-labelledby="hd-pt"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p><strong>Aviso Crítico (Conflito de Moeda)</strong></p>
                  <p>
                    Os itens selecionados (ou o carrinho) contêm moedas
                    diferentes.<br />Por favor, unifique a moeda antes de
                    prosseguir.
                  </p>
                </div>
              </div>
            </div>

            <!-- Français -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-fr">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-fr"
                  aria-expanded="false"
                  aria-controls="cp-fr"
                >
                  Français
                </button>
              </h2>
              <div
                id="cp-fr"
                class="accordion-collapse collapse"
                aria-labelledby="hd-fr"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p>
                    <strong>Avertissement Critique (Conflit de Devise)</strong>
                  </p>
                  <p>
                    Les articles sélectionnés (ou le panier) contiennent
                    différentes devises.<br />Veuillez unifier la devise avant
                    de continuer.
                  </p>
                </div>
              </div>
            </div>

            <!-- Русский -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-ru">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-ru"
                  aria-expanded="false"
                  aria-controls="cp-ru"
                >
                  Русский
                </button>
              </h2>
              <div
                id="cp-ru"
                class="accordion-collapse collapse"
                aria-labelledby="hd-ru"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p>
                    <strong>Критическое предупреждение (Конфликт валют)</strong>
                  </p>
                  <p>
                    Выбранные товары (или корзина) содержат различные валюты.<br />Пожалуйста,
                    унифицируйте валюту перед продолжением.
                  </p>
                </div>
              </div>
            </div>

            <!-- हिन्दी -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-hi">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-hi"
                  aria-expanded="false"
                  aria-controls="cp-hi"
                >
                  हिन्दी
                </button>
              </h2>
              <div
                id="cp-hi"
                class="accordion-collapse collapse"
                aria-labelledby="hd-hi"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p><strong>महत्वपूर्ण चेतावनी (मुद्रा संघर्ष)</strong></p>
                  <p>
                    चुने हुए आइटम (या कार्ट) में विभिन्न मुद्राएँ शामिल हैं।<br />कृपया
                    आगे बढ़ने से पहले अपनी मुद्रा को एकीकृत करें।
                  </p>
                </div>
              </div>
            </div>

            <!-- 中文 (普通话) -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-zh">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-zh"
                  aria-expanded="false"
                  aria-controls="cp-zh"
                >
                  中文 (普通话)
                </button>
              </h2>
              <div
                id="cp-zh"
                class="accordion-collapse collapse"
                aria-labelledby="hd-zh"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p><strong>重大警告（货币冲突）</strong></p>
                  <p>
                    所选商品（或购物车）中包含不同的货币。<br />请先统一货币后再继续操作。
                  </p>
                </div>
              </div>
            </div>

            <!-- 日本語 -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-ja">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-ja"
                  aria-expanded="false"
                  aria-controls="cp-ja"
                >
                  日本語
                </button>
              </h2>
              <div
                id="cp-ja"
                class="accordion-collapse collapse"
                aria-labelledby="hd-ja"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p><strong>重大な警告（通貨衝突）</strong></p>
                  <p>
                    選択されたアイテム（またはカート）に異なる通貨が含まれています。<br />必ず通貨を統一してから再度操作を行ってください。
                  </p>
                </div>
              </div>
            </div>

            <!-- 한국어 -->
            <div class="accordion-item">
              <h2 class="accordion-header" id="hd-ko">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#cp-ko"
                  aria-expanded="false"
                  aria-controls="cp-ko"
                >
                  한국어
                </button>
              </h2>
              <div
                id="cp-ko"
                class="accordion-collapse collapse"
                aria-labelledby="hd-ko"
                data-bs-parent="#langAccordion"
              >
                <div class="accordion-body">
                  <p><strong>중대한 경고 (통화 충돌)</strong></p>
                  <p>
                    선택된 아이템(또는 장바구니) 중 서로 다른 통화가 포함되어
                    있습니다.<br />하나의 통화로 통일한 후 다시 진행하세요.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer border-0">
          <button type="button" class="btn btn-danger" @click="handleConfirm">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * Bootstrap 5.3 (ESM import) — window.bootstrap 사용하지 않음
 * - 모달만 프로그램 방식으로 관리(show/hide/dispose)
 * - 아코디언은 Data API 사용(간단한 정적 전개/접기)
 */
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import Modal from "bootstrap/js/dist/modal";

const emits = defineEmits(["close"]);
const { proxy } = getCurrentInstance();

const modalEl = ref(null);
let modalInst = null;

function onHidden() {
  // 닫힘 완료 후 상위에 알림
  emits("close");
}

onMounted(() => {
  modalInst = Modal.getOrCreateInstance(modalEl.value, {
    backdrop: "static", // 바깥 클릭으로 닫히지 않게
    keyboard: false, // ESC로 닫히지 않게
  });
  modalEl.value.addEventListener("hidden.bs.modal", onHidden);
  modalInst.show();
});

onBeforeUnmount(() => {
  modalEl.value?.removeEventListener("hidden.bs.modal", onHidden);
  modalInst?.dispose();
  modalInst = null;
});

function handleConfirm() {
  try {
    modalInst?.hide();
  } catch (e) {
    proxy?.$toast?.error("모달 닫기 처리 중 오류가 발생했습니다.");
    // 필요 시 로깅
  }
}
</script>

<style scoped>
/* 프로젝트 공통 변수(예: --statusred)를 사용해 테두리 색상만 살짝 강조 */
.currency-conflict {
  border-color: var(--statusred);
}
</style>
